import {
  approvePatientSuggestionEndpoint,
  dismissPatientSuggestionEndpoint,
} from '@lotushealth/lotushealth_js_sdk/endpoints';
import type { ApproveSuggestionRequestT } from '@lotushealth/lotushealth_js_sdk/schemas';

import { createLotusRequestConfig } from '@/shared/api/lotus';

export async function approvePatientSuggestion(
  patientUserId: string,
  actionId: string,
  data: ApproveSuggestionRequestT
) {
  const config = await createLotusRequestConfig();
  const response = await approvePatientSuggestionEndpoint(patientUserId, actionId, data, config);
  return response.data;
}

export async function dismissPatientSuggestion(patientUserId: string, actionId: string) {
  const config = await createLotusRequestConfig();
  const response = await dismissPatientSuggestionEndpoint(patientUserId, actionId, config);
  return response.data;
}
